import React, { Component } from 'react';
import styled from 'styled-components';
import { white } from 'color-name';
import TimelineBlock from './components/100DaysTimeline.js';
import VideoSidebar from './components/VideoSidebar.js';



export const First100Days = () => (
    <div className ="custom-container">
        <div className="row">
            <div className="col-md-8">
                <h2 className= 'mb-4'>First 100 Days</h2>
                <p>A timeline of what you may experience during the first 100 days of your bone marrow transplant process</p>  
                <TimelineBlock></TimelineBlock>
            </div>

            <div className="col-md-4">
                <VideoSidebar></VideoSidebar>
            </div>
        </div>

    </div>
  )


